module.exports = __webpack_public_path__ + "static/media/play.988e925b.svg";